import request from "@/libs/request";

import { CommonRequest, CommonResponse } from "@/types/common";
import {
  GetPastBusinessBidListResponse,
  GetPastBusinessBidTotalAmountResponse,
  GetPastBusinessCorperationListResponse,
  GetPastBusinessDminstListResponse,
} from "@/types/pastbusiness";

export const GetPastBusinessTotalAmount = async (params: CommonRequest) =>
  request.post<CommonResponse<GetPastBusinessBidTotalAmountResponse>>(
    `/compute`,
    params
  );

export const GetPastBusinessDminstList = async (params: CommonRequest) =>
  request.post<CommonResponse<GetPastBusinessDminstListResponse>>(
    `/compute`,
    params
  );

export const GetPastBusinessCorperationList = async (params: CommonRequest) =>
  request.post<CommonResponse<GetPastBusinessCorperationListResponse>>(
    `/compute`,
    params
  );
export const GetPastBusinessBidList = async (params: CommonRequest) =>
  request.post<CommonResponse<GetPastBusinessBidListResponse>>(
    `/compute`,
    params
  );

export const GetPastBusinessBidListWithResult = async (params: CommonRequest) =>
  request.post<CommonResponse<GetPastBusinessBidListResponse>>(
    `/compute`,
    params
  );
